"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandableList = void 0;
var _react = require("react");
var _hooks = require("../../hooks");
var _Button = require("../../UI/Button");
var _Icon = require("../../UI/Icon");
var _ExpandableList = require("./ExpandableList.styles");
var _ExpandableList2 = require("./ExpandableList.labels");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var ExpandableList = function ExpandableList(props) {
  var _props$items = props.items,
    items = _props$items === void 0 ? [] : _props$items,
    ItemTag = props.ItemTag,
    _props$isWithRemoveAl = props.isWithRemoveAllButton,
    isWithRemoveAllButton = _props$isWithRemoveAl === void 0 ? false : _props$isWithRemoveAl,
    onRemoveAllItems = props.onRemoveAllItems;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _useListChildren = (0, _hooks.useListChildren)(items, isMobileView),
    outerDivRef = _useListChildren.outerDivRef,
    contentRef = _useListChildren.contentRef,
    extraRef = _useListChildren.extraRef,
    visibleChildren = _useListChildren.visibleChildren,
    hiddenChildren = _useListChildren.hiddenChildren;
  var getLabel = (0, _hooks.useLabels)({
    labels: _ExpandableList2.labels
  });
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isTransitionInMotion = _useState4[0],
    setIsTransitionInMotion = _useState4[1];
  var isOpenBtnVisible = hiddenChildren.length > 0;
  var styles = (0, _ExpandableList.useStyles)(props, isTransitionInMotion, isExpanded || isMobileView, isOpenBtnVisible);
  var handleRemoveAllItems = function handleRemoveAllItems() {
    if (onRemoveAllItems) {
      onRemoveAllItems();
    }
  };
  var handleOpenBtnClick = function handleOpenBtnClick() {
    setIsExpanded(true);
    setIsTransitionInMotion(true);
  };
  var handleCloseBtnClick = function handleCloseBtnClick() {
    setIsExpanded(false);
    setIsTransitionInMotion(true);
  };
  var handleTransitionEnd = function handleTransitionEnd() {
    setIsTransitionInMotion(false);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-ExpandableList'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-ExpandableList__content'],
      ref: outerDivRef,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
        className: styles['cc-ExpandableList__items'],
        ref: contentRef,
        onTransitionEnd: handleTransitionEnd,
        "data-testid": "ccExpandableList",
        children: [visibleChildren.map(function (item, index) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
            className: styles['cc-ExpandableList__item'],
            "data-is-visible": "true",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ItemTag, _objectSpread({}, item))
          }, "item_visible_".concat(index));
        }), (isExpanded || isTransitionInMotion) && hiddenChildren.map(function (item, index) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
            className: styles['cc-ExpandableList__item'],
            "data-is-visible": "true",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ItemTag, _objectSpread({}, item))
          }, "item_hidden_".concat(index));
        })]
      }), items.length > 0 && !isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-ExpandableList__open'],
        ref: extraRef,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          id: "ccExpandableListOpenBtn",
          onClick: handleOpenBtnClick,
          view: "link",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: styles['cc-ExpandableList__btn'],
            children: "+ ".concat(hiddenChildren.length, " ").concat(getLabel('open_btn'))
          })
        })
      }), items.length > 0 && isWithRemoveAllButton && isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-ExpandableList__remove-all'],
        ref: extraRef,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          id: "ccExpandableListRemoveAllBtn",
          onClick: handleRemoveAllItems,
          view: "alternate",
          color: "primary",
          shape: "round",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            name: "Trash",
            width: "20",
            height: "20"
          })
        })
      })]
    }), items.length > 0 && !isMobileView && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-ExpandableList__close'],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
        id: "ccExpandableListCloseBtn",
        onClick: handleCloseBtnClick,
        view: "link",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: styles['cc-ExpandableList__btn'],
          children: getLabel('close_btn')
        })
      })
    })]
  });
};
exports.ExpandableList = ExpandableList;